var _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import ApplicationInstance from "@ember/application/instance";
import { getOwner } from "@ember/owner";
import Service, { service } from "@ember/service";
import { tracked } from "@glimmer/tracking";
import CoreAdapter from "core/adapters/core";
import ControlTower from "wise-control-tower";
import SemeiaSessionService from "./session";
let BioExamResultsService = (_class = class BioExamResultsService extends Service {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "applicationAdapter", getOwner(this).lookup("adapter:application"));
    _initializerDefineProperty(this, "bioExamDraftCount", _descriptor, this);
    _initializerDefineProperty(this, "session", _descriptor2, this);
  }
  async loadBioExamDraftCount() {
    if (this.session.medic?.isSuperUser) {
      const response = await fetch("/api/v1/count_draft_bio_jes", {
        headers: Object.assign({
          "Content-Type": "application/json"
        }, this.applicationAdapter.headers)
      });
      if (!response.ok) {
        ControlTower.captureException(response.text);
        this.bioExamDraftCount = 0;
      }
      const content = await response.json();
      this.bioExamDraftCount = content.count;
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "bioExamDraftCount", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "session", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { BioExamResultsService as default };